import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { getService } from "@/data/services";
import { MaskLines, Reveal } from "@/components/site/Reveal";

const TABS = ["domestic", "commercial", "industrial"];

export const Sectors = () => {
  const [active, setActive] = useState("domestic");
  const s = getService(active);
  return (
    <section data-testid="sectors-section" className="bg-ink text-white py-24 sm:py-32 relative overflow-hidden">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal><p className="eyebrow text-brass mb-5">Sectors</p></Reveal>
          <h2 className="font-wide font-black uppercase text-4xl sm:text-5xl leading-[0.95] tracking-tight">
            <MaskLines lines={["Homes, businesses", "& heavy industry."]} />
          </h2>
          <div className="mt-10 flex flex-col border-t border-white/15" role="tablist">
            {TABS.map((t, i) => {
              const sv = getService(t);
              const on = t === active;
              return (
                <button key={t} role="tab" aria-selected={on} data-testid={`sector-tab-${t}`} onClick={() => setActive(t)}
                  className="group relative flex items-center justify-between py-6 border-b border-white/15 text-left">
                  <span className="flex items-baseline gap-5">
                    <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
                    <span className={`font-wide font-extrabold uppercase text-2xl sm:text-3xl transition-colors ${on ? "text-brass" : "text-white/60 group-hover:text-white"}`}>{sv.title}</span>
                  </span>
                  <ArrowRight className={`h-5 w-5 transition-[transform,opacity] ${on ? "opacity-100 translate-x-0 text-brass" : "opacity-0 -translate-x-2"}`} />
                  {on && <motion.span layoutId="sector-line" className="absolute bottom-[-1px] left-0 h-[2px] w-full bg-brass" />}
                </button>
              );
            })}
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="relative aspect-[16/11] overflow-hidden clip-notch bg-ink2">
            <AnimatePresence initial={false}>
              <motion.img key={s.slug} src={s.image} alt={s.title} initial={{ opacity: 0, scale: 1.08 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} className="absolute inset-0 h-full w-full object-cover" />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-tr from-ink/70 to-transparent" />
          </div>
          <div className="mt-8 grid gap-8 sm:grid-cols-2">
            <p className="text-slate-300 leading-relaxed" data-testid="sector-intro">{s.intro}</p>
            <ul className="space-y-2.5">
              {s.includes.slice(0, 5).map((x) => (
                <li key={x} className="flex gap-3 text-sm text-slate-200"><Check className="h-4 w-4 text-brass mt-0.5 shrink-0" />{x}</li>
              ))}
              <li><Link to={`/services/${s.slug}`} data-testid="sector-learn-more" className="inline-flex items-center gap-2 mt-3 font-bold text-brass link-underline">Explore {s.title.toLowerCase()} <ArrowRight className="h-4 w-4" /></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
